<script setup lang="ts">
const props = defineProps({
  contour: {type: String},
  img: {type: String},
});
const emits = defineEmits(['change']);
const entranceRef = ref();

onMounted(() => {
  const entranceList =
    entranceRef.value.querySelectorAll('svg > path');
  const svg = entranceRef.value.querySelectorAll('svg');
  svg[0].style.height = 300 + 'px';

  if (entranceList?.length) {
    entranceList?.[0].classList.add('active');
    entranceList?.forEach((entrance: any, index: number) => {
      entrance.style.fill = 'rgb(236 236 236)';
      entrance.addEventListener('click', () => {
        entranceList.forEach((item: any) =>
          item.classList.remove('active'),
        );
        entrance.classList.toggle('active');
        emits('change', index);
      });
    });
  }
});
onUnmounted(() => {
  entranceRef.value
    ?.querySelectorAll('svg > path')
    .forEach((entrance: any) =>
      entrance.removeEventListener('click'),
    );
});
</script>

<template>
  <div ref="entranceRef" class="genplan-entrance">
    <img :src="img" alt="" />
    <div class="genplan-entrance__contour" v-html="contour" />
  </div>
</template>

<style scoped lang="scss">
.genplan-entrance {
  position: relative;
  display: flex;

  &::v-deep(path) {
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    &.active {
      fill: #3e9eea !important;
    }
  }

  img {
    display: block;
    z-index: 100;
    pointer-events: none;
  }

  &__contour {
    position: absolute;
    top: 0;
    left: 0;
    color: #64686e;
  }
}
</style>
